export default {
  abandonProduct: 'Produkt aufgeben',
  abandonProductTips:
    'Freundliche Erinnerung: Wenn Sie [Produkt aufgeben] bestätigen, werden wir Ihr Produkt vernichten und es kann nicht wiederhergestellt werden. Das Produkt wird nicht zur Rückerstattung an den Verkäufer zurückgesendet. Bitte fahren Sie vorsichtig fort.',
  finePhotos: 'Detaillierte Fotografie',
  ordinaryPhotos: 'Einfaches Bild',
  expireText: 'Das Paket läuft bald ab',
  more: 'Mehr',
  timeExpand: 'Verlängerte Dauer',
  guaranteeService: 'Garantieservice',
  noNeed: 'Nicht benötigt',
  'i18n-0000002':
    'Ihr Artikel hat die Lagerfrist überschritten. Wir lagern ihn weitere 28 Tage. Nach dieser Frist gilt er als aufgegeben und wird entsprechend entsorgt.',
  'i18n-0000003':
    'Wenn Sie die Lagerfrist verlängern müssen, erwerben Sie bitte innerhalb von 28 Tagen den Mehrwertdienst zur Lagerverlängerung.',
  'i18n-0000004': 'Ablaufzeit der Lagerung',
  'i18n-0000016': 'Produktlagerung abgelaufen',
  'i18n-0000019': 'Lagerverlängerung unbezahlt. Artikel gilt als freiwillig aufgegeben.',
  'i18n-0000023': 'Abgeschlossen',
  refundTip: 'Nach Bestätigung wird die Lagergebühr Ihrem Konto gutgeschrieben.',
  storageEnum: {
    1: 'Lager 1, China',
    2: 'Lager 2, China',
  },
  'i18n-00001': `Ich stimme den von acbuy bereitgestellten Änderungen meiner Deklarationsinformationen zu, um die lokalen Zollbestimmungen zu erfüllen und die Zollabfertigungsraten zu verbessern. Wenn keine Versicherung abgeschlossen wird, trage ich die alleinige Verantwortung für alle daraus resultierenden Zollabfertigungspflichten und -folgen.`,
  'i18n-00002': `Ich bin mit den Änderungen nicht einverstanden. Bitte deklarieren Sie die Informationen unverändert. Ich trage die alleinige Verantwortung für alle daraus resultierenden Zollabfertigungspflichten und -folgen.`,
  'i18n-00003': 'Änderung zustimmen',
  'i18n-00004': 'Änderung nicht zustimmen',
  'i18n-00005': 'Änderung der Deklarationsinformationen',
  'i18n-00006':
    'Der Inhalt jeder Deklaration muss mehr als 25 Zeichen umfassen. Bitte anpassen und erneut einreichen',
  'i18n-00007':
    'Berechnet nach dem höheren Wert von tatsächlichem oder Volumengewicht. Jegliche Differenz wird innerhalb von 72 Stunden nach der Verpackung erstattet oder berechnet.',
  'i18n-00008':
    'Jede meldenachricht muss für {length} zeichen gesperrt werden und muss erneut eingereicht werden',
  'i18n-00009':
    '{AI} hat noch unbezahlte Value-Added-Services. Um diese zu behalten, schließen Sie bitte die Zahlung ab und warten Sie, bis der Service abgeschlossen ist, bevor Sie das Paket einreichen. Wenn Sie sich entscheiden, das Paket jetzt einzureichen, storniert das System automatisch die entsprechenden Value-Added-Services, die noch nicht bezahlt wurden.',
}
